import React, { useState } from 'react';
import { X, CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { useLanguage } from '../../context/LanguageContext';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultSubject?: string;
}
export function ContactModal({
  isOpen,
  onClose,
  defaultSubject = 'General Inquiry'
}: ContactModalProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    t
  } = useLanguage();
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-106">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-in zoom-in-95 duration-200" role="dialog" aria-modal="true" data-id="element-107">
        {/* Header */}
        <div className="bg-caces-navy p-6 flex justify-between items-center text-white" data-id="element-108">
          <h3 className="text-xl font-serif font-semibold" data-id="element-109">{t.modal.title}</h3>
          <button onClick={onClose} className="text-white/80 hover:text-white transition-colors" aria-label="Close modal" data-id="element-110">
            <X size={24} data-id="element-111" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 md:p-8" data-id="element-112">
          {isSuccess ? <div className="text-center py-8" data-id="element-113">
              <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-114">
                <CheckCircle className="w-8 h-8 text-green-600" data-id="element-115" />
              </div>
              <h4 className="text-2xl font-serif font-bold text-caces-navy mb-2" data-id="element-116">
                {t.modal.success.title}
              </h4>
              <p className="text-gray-600 mb-6" data-id="element-117">{t.modal.success.desc}</p>
              <Button onClick={onClose} fullWidth data-id="element-118">
                {t.modal.success.close}
              </Button>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-119">
              <div data-id="element-120">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-121">
                  {t.modal.form.name}
                </label>
                <input type="text" id="name" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none" placeholder={t.modal.form.namePh} data-id="element-122" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-123">
                <div data-id="element-124">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-125">
                    {t.modal.form.email}
                  </label>
                  <input type="email" id="email" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none" placeholder={t.modal.form.emailPh} data-id="element-126" />
                </div>
                <div data-id="element-127">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-128">
                    {t.modal.form.phone}
                  </label>
                  <input type="tel" id="phone" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none" placeholder={t.modal.form.phonePh} data-id="element-129" />
                </div>
              </div>

              <div data-id="element-130">
                <label htmlFor="specialty" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-131">
                  {t.modal.form.specialty}
                </label>
                <select id="specialty" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none" defaultValue={defaultSubject} data-id="element-132">
                  <option data-id="element-133">{t.modal.form.options.general}</option>
                  <option data-id="element-134">{t.modal.form.options.laparoscopic}</option>
                  <option data-id="element-135">{t.modal.form.options.urological}</option>
                  <option data-id="element-136">{t.modal.form.options.colorectal}</option>
                  <option data-id="element-137">{t.modal.form.options.oncological}</option>
                  <option data-id="element-138">{t.modal.form.options.orthopedic}</option>
                  <option data-id="element-139">{t.modal.form.options.ent}</option>
                  <option data-id="element-140">{t.modal.form.options.other}</option>
                </select>
              </div>

              <div data-id="element-141">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-142">
                  {t.modal.form.message}
                </label>
                <textarea id="message" rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-caces-accent focus:border-transparent outline-none" placeholder={t.modal.form.messagePh} data-id="element-143"></textarea>
              </div>

              <div className="bg-gray-50 p-3 rounded-md text-xs text-gray-500" data-id="element-144">
                <p data-id="element-145">
                  <strong data-id="element-146">{t.modal.form.note}</strong>
                </p>
              </div>

              <Button type="submit" fullWidth isLoading={isSubmitting} data-id="element-147">
                {t.modal.form.submit}
              </Button>
            </form>}
        </div>
      </div>
    </div>;
}